<template>
  <CardGraphicWithBorder
    ref="card"
    img-alt="Dashboard"
    img-src="/images/family/dashboard.svg"
    :show-controls="true"
    :close-click-outside="true"
  >
    <template #title> Accompagnez ses révisions </template>
    <template #description>
      <p>
        Demandez à <strong>{{ displayName }}</strong> de
        <strong>partager ses données</strong> pour réviser sur son compte.
      </p>
    </template>
    <template #footer>
      <FamilyButtonAskForShareSettings :member="member">
        Demander à <strong>{{ displayName }}</strong>
      </FamilyButtonAskForShareSettings>
    </template>
  </CardGraphicWithBorder>
</template>
<script setup lang="ts">
interface Props {
  member: FamilyMember;
}
const props = defineProps({
  member: null
});

const { displayName } = useFamilyMember(toRef(() => props.member));
</script>
<style lang="scss" scoped>
.card {
  justify-self: center;
}
</style>
